function teamSetting(code) {
    return teamNameByCode(code*1)
}

function teamNameByCode(code) {
    let teamName = {};
    
    if(code===1001) teamName = {kor:"롯데", eng:"LOTTE", full:"롯데 자이언츠"};
    else if(code===2001) teamName = {kor:"한화", eng:"HANWHA", full:"한화 이글스"};
    else if(code===3001) teamName = {kor:"LG", eng:"LG", full:"LG 트윈스"};
    else if(code===4001) teamName = {kor:"NC", eng:"NC", full:"NC 다이노스"};
    else if(code===5001) teamName = {kor:"SSG", eng:"SSG", full:"SSG 랜더스"};
    else if(code===6001) teamName = {kor:"기아", eng:"KIA", full:"KIA 타이거즈"};
    else if(code===7001) teamName = {kor:"키움", eng:"KIWOOM", full:"키움 히어로즈"};
    else if(code===8001) teamName = {kor:"두산", eng:"DOOSAN", full:"두산 베어스"};
    else if(code===9001) teamName = {kor:"삼성", eng:"SAMSUNG", full:"삼성 라이온스"};
    else if(code===10001) teamName = {kor:"kt", eng:"kt", full:"KT 위즈"};
    
    return teamName;
}

function teamListObj() {
    return [
        {teamId: 1001, teamName: '롯데', teamEngName: "LT"},
        {teamId: 2001, teamName: '한화', teamEngName: "HH"},
        {teamId: 3001, teamName: 'LG', teamEngName: "LG"},
        {teamId: 4001, teamName: 'NC', teamEngName: "NC"},
        {teamId: 5001, teamName: 'SSG', teamEngName: "SSG"},
        {teamId: 6001, teamName: 'KIA', teamEngName: "KIA"},
        {teamId: 7001, teamName: '키움', teamEngName: "KW"},
        {teamId: 8001, teamName: '두산', teamEngName: "DS"},
        {teamId: 9001, teamName: '삼성', teamEngName: "SS"},
        {teamId: 10001, teamName: 'KT', teamEngName: "KT"}
    ]
}

export {teamSetting, teamListObj};